import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'gtw-maintenance',
    template: `
    <div class="error-page">
      <div class="error-page__icon">
        <i class="fa fa-wrench"></i>
      </div>
      <h1 class="error-page__code">Under Maintenance</h1>
      <p class="error-page__message">This system is currently undergoing scheduled maintenance.</p>
      <p class="error-page__hint">Please try again later. We apologize for the inconvenience.</p>
    </div>
  `,
    styles: [`
    .error-page {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      min-height: 60vh;
      text-align: center;
      padding: 40px;
    }
    .error-page__icon { font-size: 64px; color: #f0ad4e; margin-bottom: 16px; }
    .error-page__code { font-size: 36px; font-weight: 700; margin: 0; color: #333; }
    .error-page__message { font-size: 20px; color: #555; margin: 8px 0; }
    .error-page__hint { font-size: 14px; color: #888; }
  `],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class MaintenanceComponent {}
